/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Themedarkdescription3Inputs */

const zh_systemsettings_themedarkdescription3 = /** @type {(inputs: Systemsettings_Themedarkdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始终使用深色主题。`)
};

const en_systemsettings_themedarkdescription3 = /** @type {(inputs: Systemsettings_Themedarkdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always use the dark theme.`)
};

const es_systemsettings_themedarkdescription3 = /** @type {(inputs: Systemsettings_Themedarkdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar siempre el tema oscuro.`)
};

/**
* | output |
* | --- |
* | "Always use the dark theme." |
*
* @param {Systemsettings_Themedarkdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_themedarkdescription3 = /** @type {((inputs?: Systemsettings_Themedarkdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Themedarkdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_themedarkdescription3(inputs)
	if (locale === "en") return en_systemsettings_themedarkdescription3(inputs)
	return es_systemsettings_themedarkdescription3(inputs)
});
export { systemsettings_themedarkdescription3 as "systemSettings_themeDarkDescription" }